"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediaItem = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
exports.mediaItem = (0, basic_1.applyBase)({
    cardContent: {
        px: 4,
        pb: ['30px', 4],
        color: 'white',
        position: 'absolute',
        bottom: 0,
        width: '100%',
        textAlign: 'center',
        '.card-title': Object.assign({}, font_faces_1.FONT_SIZE.M),
        '.card-subtitle': Object.assign({}, font_faces_1.FONT_SIZE.LARGE),
    },
});
//# sourceMappingURL=media-item.js.map